import 'shared/global';
import gridView from 'components/gridView';
import 'components/subnav';

try {
    gridView({
        parentContainer: $('#photos-landing-container'),
        options: {
            endPoint: `/shows/{slug}/xhr/photos/offset/{offset}/limit/{limit}/`,
        },
        useTemplate: 'showAlbumsTpl',
    });
} catch (e) {
    console.error('Photo Landings failed to load');
}
